import { useLazyQuery,gql } from "@apollo/client";


const GET_PRODUCT_QUESTION_DOC=gql`
query GetProductQuestionDocument($orderId: Int, $token: String) {
    getProductQuestionDocument(orderId: $orderId, token: $token) {
      success
      message
      data {
        answer
        doc_url
      }
    }
  }
`;

export const GetProductQuestionDocAction=()=>{
    const [
        getProductQuetionDocResponseFunction,
        getProductQuestionDocResponseData
    ]=useLazyQuery(GET_PRODUCT_QUESTION_DOC,{
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-and-network",
        onCompleted:({getProductQuestionDocument:responseData})=>{
            if(responseData.success){
            }else{

            }
        }
    })

    const getProductQuestionDocQueryData=getProductQuestionDocResponseData;

    const initGetProductQuetionDocData=(data)=>{
     getProductQuetionDocResponseFunction({
        variables:data
     })
    }
    return {initGetProductQuetionDocData, getProductQuestionDocQueryData}
} 